<template>
  <SingleTranscript :transcriptContent="activeTranscriptContent" />
</template>

<script>
import SingleTranscript from '../components/SingleTranscript'

export default {
  data () {
    return {
      activeTranscriptContent: {}
    }
  },
  components: {
    SingleTranscript
  },
  created() {
    this.activeTranscriptContent = require(`@/stories/${this.$route.name}.json`)
  },
  watch: {
    $route() {
      this.activeTranscriptContent = require(`@/stories/${this.$route.name}.json`)
    }
  }
}
</script>